import { Box } from '@chakra-ui/react';
import { useParentSize } from '@visx/responsive';
import { useTooltip, useTooltipInPortal } from '@visx/tooltip';
import { Zoom } from '@visx/zoom';

import { OrgChartTooltip } from './OrgChartTooltip';
import { OrgChartTree } from './OrgChartTree';
import { Employee } from './constants';

export function OrgChartHorizontal() {
  const { parentRef: parentContainerRef, width: parentWidth, height: parentHeight } = useParentSize();

  const { tooltipData, tooltipLeft, tooltipTop, tooltipOpen, showTooltip, hideTooltip } = useTooltip<Employee>();

  const {
    containerBounds,
    containerRef: tooltipContainerRef,
    TooltipInPortal,
  } = useTooltipInPortal({
    detectBounds: true,
    debounce: 500,
    scroll: true,
    zIndex: 1500,
  });

  const handleMouseMove = (event: React.MouseEvent, data: Employee) => {
    const containerX = event.clientX - containerBounds.left;
    const containerY = event.clientY - containerBounds.top;

    showTooltip({
      tooltipData: data,
      tooltipLeft: containerX,
      tooltipTop: containerY,
    });
  };

  const initialTransform = {
    scaleX: 1,
    scaleY: 1,
    translateX: 40,
    translateY: 0,
    skewX: 0,
    skewY: 0,
  };

  return (
    <Box w="100%" h="100%" ref={parentContainerRef}>
      <Box style={{ width: parentWidth, height: parentHeight }} ref={tooltipContainerRef}>
        <Zoom<SVGSVGElement>
          width={parentWidth}
          height={parentHeight}
          scaleXMin={0.5}
          scaleXMax={1}
          scaleYMin={0.5}
          scaleYMax={1}
          initialTransformMatrix={initialTransform}
        >
          {(zoom) => (
            <OrgChartTree
              parentWidth={parentWidth}
              parentHeight={parentHeight}
              zoom={zoom}
              handleMouseMove={handleMouseMove}
              hideTooltip={hideTooltip}
            />
          )}
        </Zoom>
        {tooltipOpen && tooltipData && (
          <TooltipInPortal
            key={`${tooltipTop}-${tooltipLeft}`}
            top={tooltipTop}
            left={tooltipLeft}
            unstyled
            applyPositionStyle
          >
            <OrgChartTooltip
              name={tooltipData.name}
              profilePhoto={tooltipData.profilePhoto}
              mentees={tooltipData.mentees}
              mentorMatch={tooltipData.mentorMatch}
            />
          </TooltipInPortal>
        )}
      </Box>
    </Box>
  );
}
